export class SubmenuModel {
    id: number;
    submenu: string;
    component: string;
    userRoles: any;
}
